export default {
    data: [
      {
        id: 1,
        username: "user",
        name: "Usuario",
        password: "123456",
        avatar: {
            color: "#f56a00",
            name: "User"
        }
      },
      {
        id: 2,
        username: "daim_user",
        name: "Usuario DAIM",
        password: "Ceit@2020",
        avatar: {
            color: "#7265e6",
            name: "DAIM"
        }
      },
      {
        id: 3,
        username: "tp_user",
        name: "Usuario TP",
        password: "Ceit@2020",
        avatar: {
            color: "#ffbf00",
            name: "TP"
        }
      },
      {
        id: 4,
        username: "ndt_user",
        name: "Usuario NDT",
        password: "Ceit@2020",
        avatar: {
            color: "#00a2ae",
            name: "NDT"
        }
      }
    ]
  };
  